import React, { useState } from 'react'
import { Table, Empty, TableProps } from 'antd'
import styles from './CustomTable.module.scss'
import { useTranslation } from 'next-i18next'

interface CustomTableProps extends TableProps<any> {
  pageSize?: number
  emptyText?: string
  hidePagination?: boolean
}

const CustomTable: React.FC<CustomTableProps> = (props) => {
  const { t } = useTranslation()
  const { pageSize = 5, emptyText = t('table.EmptyData'), hidePagination = false, ...restProps } = props
  const [pageSizeState, setPageSizeState] = useState<number>(pageSize)

  const localLabels = {
    filterTitle: t('table.customFilter'),
    filterConfirm: t('table.confirmSearch'),
    emptyText: <Empty description={emptyText} />,
    triggerDesc: t('table.triggerDesc'),
    triggerAsc: t('table.triggerAsc'),
    cancelSort: t('general.Cancel')
  }

  return (
    <Table
      {...restProps}
      className={styles['default-padding']}
      locale={localLabels}
      pagination={hidePagination ? false: {
        pageSize: pageSizeState,
        pageSizeOptions: [3, 5, 10, 20, 50],
        responsive: true,
        onChange(page, pageSize) {
          setPageSizeState(pageSize)
        },
      }}
    />
  )
}

export default CustomTable
